export const countryMap: Record<string, Array<string>> = {
    "USAmazon": [
        "US",
        "CA",
        "MX",
        "BR",
        "CO", // Colombia
        "CL", // Chile
    ],
    "EUAmazon": [
        "GB",
        "DE",
        "FR",
        "IT",
        "ES",
        "IN",
        "AE",
        "TR",
        "SA",
        "NL",
        "SE",
        "PL",
        "EG",
        "BE",
        "ZA",
        "IE", // Ireland
        "AT", // Austria
        "DK", // Denamrk
        "PT", // Portugal
        "MC", // Monaco
        "NG"  // Nigeria
    ],
    "JPAmazon": [
        "JP",
        "AU",
        "SG",
        "ID", // Indonesia
        "TH" // Thailand
    ]
};

export enum PipelineStageEnum {
    Development = 'Development',
    BetaNA = 'Beta-NA',
    BetaEU = 'Beta-EU',
    BetaEU_ZAZ = 'Beta-EU-ZAZ',
    BetaFE = 'Beta-FE',
    GammaNA = 'Gamma-NA',
    GammaEU = 'Gamma-EU',
    GammaEU_ZAZ = 'Gamma-EU-ZAZ',
    GammaFE = 'Gamma-FE',
    ProdNA = 'Prod-NA',
    ProdEU = 'Prod-EU',
    ProdEU_ZAZ = 'Prod-EU-ZAZ',
    ProdFE = 'Prod-FE'
}

// Use Beta-NA stage for local development to enable auth and API calls, otherwise use the template replacement
export const pipelineStage = process.env.NODE_ENV === 'development' ? PipelineStageEnum.BetaNA : "Prod-NA";

// Derives the current stage from the hostname: portal.gamma.na.portal.fee... → Gamma.
// Each stage is a separate deployment at its own hostname. Defaults to Beta
// (covers localhost / dev-dsk, which have no stage segment).
export function getStageFromHostname(hostname: string = window.location.hostname): string {
    const host = hostname.toLowerCase();
    if (host.includes('.gamma.')) return 'Gamma';
    if (host.includes('.prod.')) return 'Prod';
    return 'Beta';
}

// True when a stage name (e.g. 'Beta' | 'Gamma' | 'Prod', as returned by
// getStageFromHostname or a promotion target) refers to Prod. Case-insensitive.
export const isProdStageName = (stage: string | null | undefined): boolean =>
    (stage || '').toLowerCase() === 'prod';

// Stages where the config registry page is visible. Add 'Prod' to show it in prod.
export const CONFIG_REGISTRY_ENABLED_STAGES: string[] = ['Beta', 'Gamma'];

export const isConfigRegistryEnabled = (stage: string = getStageFromHostname()): boolean =>
    CONFIG_REGISTRY_ENABLED_STAGES.some((s) => s.toLowerCase() === (stage || '').toLowerCase());

// Users allowed to propose config registry changes. Keep in sync with the backend allowlist.
export const CONFIG_REGISTRY_EDITORS: string[] = ['rimsik', 'abbisht', 'jigonro', 'yanynga', 'adishrey'];

export const isConfigRegistryEditor = (alias: string | null | undefined): boolean =>
    !!alias && CONFIG_REGISTRY_EDITORS.some((a) => a.toLowerCase() === alias.toLowerCase());

// Users allowed to approve config registry changes. Must be sps-fsx-dev members
// (https://permissions.amazon.com/a/team/sps-fsx-dev); keep in sync with the backend allowlist.
export const CONFIG_REGISTRY_APPROVERS: string[] = ['rimsik', 'abbisht', 'jigonro', 'yanynga', 'adishrey'];

export const isConfigRegistryApprover = (alias: string | null | undefined): boolean =>
    !!alias && CONFIG_REGISTRY_APPROVERS.some((a) => a.toLowerCase() === alias.toLowerCase());
